import { render, staticRenderFns } from "./PrinciplesInPractice.vue?vue&type=template&id=05341e2b&"
import script from "./PrinciplesInPractice.vue?vue&type=script&lang=ts&"
export * from "./PrinciplesInPractice.vue?vue&type=script&lang=ts&"
import style0 from "./PrinciplesInPractice.vue?vue&type=style&index=0&id=05341e2b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports